import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import settingsIconActive from '../../../images/salescatalyst/configuration_icon_active.png';
// import closePopupIcon from '../../../images/close-drawer-icon_default.png';
// import SalesCatalystConfigurationPackage from './SalesCatalystConfigurationPackage';
// import UpdatedSmartSearch from '../../common/SmartSearch/UpdatedSmartSearch';
// import GenericButton from '../../common/GenericButton';
// import { availableToAddSpecificSelection } from '../../../util/SalesCatalystUtils';
import UserPreference from '../../../containers/UserPreference';
import {
  SALES_CATALYST_DATA_SELECTION,
  SALES_CATALYST_DATA_SUBENTITIES,
  SC_SELECTED_SUBENTITY_LIST,
  SC_PACKAGE,
  PREFERENCE_SALES_CATALYST,
  PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST,
} from '../../../constants';

class SalesCatalystConfigurationScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ssDefaultSection: !_.isEmpty(props.subEntities) ? _.toLower(SC_PACKAGE) : undefined,
    };
  }

  callValidateMethod = () => {
    const stateValue = this.smartSearchBox.current.state;
    this.props.validateAddSpecificSelection(this.props.scDataSelection,
      SALES_CATALYST_DATA_SUBENTITIES, SALES_CATALYST_DATA_SELECTION, stateValue);
  }

  closePopupFn = () => {
    const { subEntities, nodeRef, salesCatalystActions } = this.props;
    if (!_.isEmpty(subEntities)) {
      salesCatalystActions.deleteSalesCatalystSelection(SALES_CATALYST_DATA_SELECTION,
        _.camelCase(SALES_CATALYST_DATA_SUBENTITIES));
    }
    nodeRef.hide();
  }

  applyPackageSettings = data => {
    const selPackageTemplate =
    data[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST];
    if (!_.isEmpty(selPackageTemplate)) {
      this.props.salesCatalystActions.setCofigurationPackageData(
        {
          templateId: selPackageTemplate.value,
          templateName: selPackageTemplate.label,
        },
        SC_SELECTED_SUBENTITY_LIST
      );
    }
  }

  render() {
    const { ssDefaultSection } = this.state;
    return (
      <div className="position-relative sc-config-screen">
        <h3 className="margin-top-10 margin-bottom-15 text-align-center">
          <img className="sc-icon-img margin-right-10" src={settingsIconActive} alt="Session Settings" />
          {`${_.isEmpty(ssDefaultSection) ? 'Session Settings' : 'Package Settings'}`}
        </h3>
        <UserPreference
          screenType={'session'}
          sessionClose={this.closePopupFn}
          defaultSection={ssDefaultSection}
          saveSettingsFn={this.applyPackageSettings}
          sessionType={PREFERENCE_SALES_CATALYST}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    subEntities: state.salesCatalyst.dataSelection.subEntities,
    kpiInfo: state.crosstab.kpiInfo,
    scDataSelection: state.salesCatalyst.dataSelection,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

SalesCatalystConfigurationScreen.propTypes = {
  nodeRef: PropTypes.shape({}),
  addInputDataPointsSelection: PropTypes.func,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesCatalystConfigurationScreen);
